export default __webpack_public_path__ + "static/media/question-analysis.9d1578f0.png";